import React, {Fragment, useState} from "react";
import { SmartErrorDiv } from "./SmartErrorDiv";
import {EyeFill, EyeSlashFill} from "react-bootstrap-icons";

import './FormInputPassword.scss' ;

const FormInputPassword = ( { register, iconColor, pattern, readOnly, label, sectionName, name, style, className, formErrors, maxLength, required, placeHolder, autocomplete } ) =>
{
    const classText = className === undefined ? "form-control" : '' ;

    const [ type, setType ] = useState ( false ) ;

    const togglePasswordView = () =>
    {
        setType ( (type) => !type ) ;
    }

    const typeText = type ? 'text' : 'password' ;
    const eye = type ? <EyeSlashFill/> : <EyeFill/>

    const iconStyle = iconColor === undefined ? {} : { color: iconColor} ;

    return (
        <Fragment>
            <div className="password-box">
                <input readOnly={readOnly}
                       autoComplete={autocomplete}
                       placeholder={placeHolder}
                       type={typeText}
                       className={classText} {...register(sectionName + '.' + name, {
                    required: required,
                    maxLength: maxLength,
                    pattern: pattern,
                })} />
                <i className='bi' onClick={togglePasswordView} style={iconStyle}>{eye}</i>
            </div>
            <SmartErrorDiv sectionName={sectionName} name={name} maxLength={maxLength} formErrors={formErrors}/>
        </Fragment>
)
}

export {
    FormInputPassword
} ;
